import {
  Box,
  Circle,
  Flex,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import React from "react";
import Jobs_tab from "../../../Components/Recruiter/Company_profile/Jobs_tab";
import ProfileTab from "../../../Components/Recruiter/Company_profile/ProfileTab";
import back from "../../../Assets/back_icon.png";
import epilouge from "@fontsource/epilogue";
import roboto from "@fontsource/roboto";
import { useNavigate } from "react-router-dom";

const Company_profile = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(-1);
  };
  return (
    <div>
      <Box p={[2, 2, 20, 20]} pt={[5, 5, 10, 10]} mt={[12, 12, 16, 16]}>
        <Flex flexDir="column">
          {/* heading */}
          <Flex gap={[4,4,4,4,4,10]} align="center">
            <Circle cursor="pointer" onClick={handleClick}>
              <img src={back} alt="back_icon" />
            </Circle>
            <Heading
              fontFamily={"Epilogue"}
              fontSize={[18,18,18,20,20,24,24]}
              fontWeight={600}
              color="#544D5E"
            >
              Manage Company Profile
            </Heading>
          </Flex>
          {/* Tabs */}
          <Box mt={[0, 0, 5, 5]}>
            <Tabs variant="unstyled">
              <TabList>
                <Tab
                  _selected={{
                    borderBottom: "2px solid #6C56FB",
                    color: "#6C56FB",
                    fontWeight: "550",
                  }}
                  w={100}
                >
                  <Text fontSize={[16,16,20,20,20,20,20]} fontFamily={"Roboto"}>
                    Profile
                  </Text>
                </Tab>
                <Tab
                  _selected={{
                    borderBottom: "2px solid #6C56FB",
                    color: "#6C56FB",
                    fontWeight: "550",
                  }}
                  w={100}
                >
                  <Text fontSize={[16,16,20,20,20,20,20]} fontFamily={"Roboto"}>
                    Jobs
                  </Text>
                </Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  <ProfileTab />
                </TabPanel>
                <TabPanel>
                  <Jobs_tab />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        </Flex>
      </Box>
    </div>
  );
};
export default Company_profile;
